/* istanbul ignore file */
export { default } from './Accordion';
